const ALLOWED_TAGS = new Set([
  "P",
  "BR",
  "STRONG",
  "B",
  "EM",
  "I",
  "U",
  "UL",
  "OL",
  "LI",
  "SPAN",
]);

const REMOVED_TAGS = new Set([
  "SCRIPT",
  "IFRAME",
  "OBJECT",
  "EMBED",
  "LINK",
  "META",
  "STYLE",
  "FORM",
  "INPUT",
]);

const ALLOWED_ALIGN_CLASSES = new Set([
  "ql-align-left",
  "ql-align-center",
  "ql-align-right",
  "ql-align-justify",
]);

const ALLOWED_ALIGN = new Set(["left", "center", "right", "justify"]);

const unwrap = (node) => {
  const parent = node.parentNode;
  if (!parent) {
    node.remove();
    return;
  }
  while (node.firstChild) {
    parent.insertBefore(node.firstChild, node);
  }
  node.remove();
};

const sanitizeClass = (value) =>
  String(value || "")
    .split(/\s+/)
    .filter((cls) => ALLOWED_ALIGN_CLASSES.has(cls))
    .join(" ");

const sanitizeStyle = (value) => {
  const match = String(value || "").match(/text-align\s*:\s*([a-z]+)/i);
  const align = match?.[1]?.toLowerCase();
  return ALLOWED_ALIGN.has(align) ? `text-align: ${align}` : "";
};

const sanitizeElement = (el) => {
  if (REMOVED_TAGS.has(el.tagName)) {
    el.remove();
    return;
  }
  if (!ALLOWED_TAGS.has(el.tagName)) {
    unwrap(el);
    return;
  }

  [...el.attributes].forEach((attr) => {
    const name = attr.name.toLowerCase();
    if (name === "class") {
      const next = sanitizeClass(attr.value);
      if (next) el.setAttribute("class", next);
      else el.removeAttribute(attr.name);
      return;
    }
    if (name === "style") {
      const next = sanitizeStyle(attr.value);
      if (next) el.setAttribute("style", next);
      else el.removeAttribute(attr.name);
      return;
    }
    el.removeAttribute(attr.name);
  });
};

export const sanitizeInviteDescriptionHtml = (html) => {
  if (!html || typeof html !== "string") return "";
  if (typeof DOMParser === "undefined") return "";

  const doc = new DOMParser().parseFromString(html, "text/html");
  const root = doc.body;
  [...root.querySelectorAll("*")].forEach(sanitizeElement);
  return root.innerHTML.trim();
};

export const inviteDescriptionHasContent = (html) =>
  Boolean(
    String(html || "")
      .replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/\s+/g, " ")
      .trim()
  );
